// extracted by mini-css-extract-plugin
export default {"ScrollSnapContainer":"ScrollSnapContainer_ehhH0"};